// src/services/roleService.js
// Consolidated role service - imports from focused permission services
// This maintains backward compatibility while using the new modular structure

// Import constants
import { ROLES, PERMISSION_LEVELS, PRODUCTS } from './constants/roleConstants';
import {
    hasPermission,
    hasAdminAccess,
    isCreatorOrSuperAdmin,
    getPermissionValue
} from './permissions/permissionHelpers';
import { checkSuperAdmin } from './permissions/adminPermissionService';
import {
    getUserProductRole,
    canCreateInProduct,
    getUserProducts
} from './permissions/productPermissionService';
import {
    getDataroomRole,
    getUserDatarooms,
    assignDataroomRole,
    getDataroomUsers,
    removeDataroomUser
} from './permissions/dataroomPermissionService';
import {
    getEquityRole,
    getUserCompanies,
    assignEquityRole,
    getCompanyUsers,
    removeEquityUser
} from './permissions/equityPermissionService';
import {
    getCapRaiseRole,
    getUserRounds,
    assignCapRaiseRole,
    getRoundUsers,
    removeCapRaiseUser
} from './permissions/capRaisePermissionService';

const RoleService = {
    // Constants
    ROLES,
    PERMISSION_LEVELS,
    PRODUCTS,

    // Global Product Roles
    checkSuperAdmin,
    getUserProductRole,
    canCreateInProduct,
    getUserProducts,

    // Project-Specific Roles
    getDataroomRole,
    getEquityRole,
    getCapRaiseRole,
    getUserDatarooms,
    getUserCompanies,
    getUserRounds,

    // Assign Roles
    assignDataroomRole,
    assignEquityRole,
    assignCapRaiseRole,

    // Permission Helpers
    hasPermission,
    hasAdminAccess,
    isCreatorOrSuperAdmin,
    getPermissionValue,

    // Get Users for Projects
    getDataroomUsers,
    getCompanyUsers,
    getRoundUsers,

    // Remove Users from Projects
    removeDataroomUser,
    removeEquityUser,
    removeCapRaiseUser,
};

// Re-export for individual imports
export { ROLES, PERMISSION_LEVELS, PRODUCTS };
export {
    hasPermission,
    hasAdminAccess,
    isCreatorOrSuperAdmin,
    getPermissionValue
};
export { checkSuperAdmin };
export {
    getUserProductRole,
    canCreateInProduct,
    getUserProducts
};
export {
    getDataroomRole,
    getUserDatarooms,
    assignDataroomRole,
    getDataroomUsers,
    removeDataroomUser
};
export {
    getEquityRole,
    getUserCompanies,
    assignEquityRole,
    getCompanyUsers,
    removeEquityUser
};
export {
    getCapRaiseRole,
    getUserRounds,
    assignCapRaiseRole,
    getRoundUsers,
    removeCapRaiseUser
};

export default RoleService;